import { motion } from "framer-motion";
import { Quote } from "lucide-react";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 bg-[#E8F0F8] overflow-hidden"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <div className="text-xs tracking-[0.3em] uppercase text-[#1D4E89] font-medium mb-5">
          Words from clients
        </div>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-serif text-4xl md:text-5xl text-[#0B2B40] tracking-tight leading-tight font-light"
        >
          The work speaks for itself —{" "}
          <span className="italic">in the lives it changes.</span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="mt-14 bg-white border border-white/80 shadow-[0_18px_50px_rgba(11,43,64,0.06)] p-10 md:p-14 mx-auto max-w-2xl"
        >
          <Quote size={28} className="text-[#1D4E89] mx-auto" />
          <p className="font-serif italic text-2xl md:text-3xl text-[#0B2B40] leading-snug mt-6">
            Client testimonials are currently being gathered from our recent
            cohort. Real stories — from real people — will appear here soon.
          </p>
          <div className="mt-8 text-xs tracking-[0.25em] uppercase text-[#4A5568]">
            — Coming Soon
          </div>
        </motion.div>

        <p className="mt-10 text-[#4A5568] font-light max-w-xl mx-auto">
          Were you coached by Reza?{" "}
          <a
            href="#contact"
            className="text-[#0B2B40] border-b border-[#0B2B40] hover:text-[#1D4E89] hover:border-[#1D4E89] transition-colors"
            data-testid="share-testimonial-link"
          >
            Share your story
          </a>
          .
        </p>
      </div>
    </section>
  );
};

export default Testimonials;
